import type { TaxRateDetailPublic } from "@common/client"
import { TAX_CLASS_LABELS } from "@common/lib/charge-labels"
import { countryName } from "@common/lib/country"
import { z } from "zod"
import type { GroupLabel } from "@/lib/grouping"

export const GROUPINGS = ["country", "region", "tax_class"] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const GROUPING_LABELS: Record<Grouping, string> = {
  country: "Country",
  region: "Region",
  tax_class: "Applies to",
}

export function taxRateGroup(
  rate: TaxRateDetailPublic,
  grouping: Grouping,
): GroupLabel {
  switch (grouping) {
    case "country":
      return rate.country
        ? { key: rate.country, label: countryName(rate.country) }
        : { key: "", label: "Any country" }
    case "region":
      return rate.region
        ? {
            key: `${rate.country ?? ""}:${rate.region}`,
            label: regionLabel(rate.region, rate.country),
          }
        : { key: "", label: "Any region" }
    case "tax_class":
      return { key: rate.tax_class, label: TAX_CLASS_LABELS[rate.tax_class] }
  }
}

function regionLabel(region: string, country: string | null): string {
  return country ? `${region} (${countryName(country)})` : region
}
